import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Text, CheckboxFieldReduxFormWrapper } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const InternationalCheckbox = ({
  name,
  elmId,
  onChange,
  isInternationalChecked = false,
}) => {
  return (
    <>
      <Field
        className={cx('u-mb-0')}
        name={name}
        component={CheckboxFieldReduxFormWrapper}
        checkboxLabel='International Address'
        onChange={onChange}
        elmId={`${elmId}_international_checkbox`}
      />
      <Text.Body size='small' color='gray'>
        {isInternationalChecked
          ? 'Provide your address in one line. Use commas to separate address elements. Example: Mr. J Brownhall, 264 High Street, ALLAMBIE NSW 2100, AUSTRALIA'
          : 'Please provide your physical address. Example: 123 Main St. Do not use a PO Box.'}
      </Text.Body>
    </>
  )
}

InternationalCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  elmId: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  isInternationalChecked: PropTypes.bool,
}

export default InternationalCheckbox
